<template>
  <app-layout title="Consents" :version="version" :bannerSetting="bannerSetting">
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          {{ project.domain_name }}
        </h2>
        <div>
          <span class="hidden text-sm ml-1 mr-5 cursor-pointer text-gray-500"
            ><span class="text-xs text-[#41b883]">&#9679;</span>
            แบนเนอร์กำลังทำงาน
          </span>
          <jet-button
            class="
              hidden
              cursor-pointer
              inline-flex
              items-center
              px-4
              py-2
              bg-yr-primary-ii-500
              border border-transparent
              rounded-md
              font-semibold
              text-xs text-white
              uppercase
              tracking-widest
              hover:bg-yr-primary-ii-600
              active:bg-yr-primary-ii-700
              focus:outline-none
              focus:border-yr-primary-ii-700
              focus:ring
              focus:ring-yr-primary-ii-300
              transition
            "
          >
            ตรวจสอบสถานะ
          </jet-button>
        </div>
      </div>
    </template>

    <div class="mx-auto sm:px-6 lg:px-8">
      <div class="text-sm font-medium text-center text-yr-primary-ii-500">
        <ul class="flex flex-wrap -mb-px">
          <li
            v-for="(tabContent, index) in tabsContent"
            :key="index"
            class="mr-2"
          >
            <Link
              :href="route(`projects.${tabContent.link}.index`, project)"
              class="inline-block p-4 rounded-t-lg border-b-[3px]"
              :class="
                tabContent.link === lastPath
                  ? 'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'
                  : 'border-transparent hover:border-yr-primary-ii-400'
              "
              >{{ tabContent.title }}</Link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="pb-12">
      <div class="mx-auto sm:px-6 lg:px-8">
        <div
          class="
            p-6
            sm:px-8
            bg-white
            overflow-hidden
            shadow-xl
            sm:rounded-lg
            grid grid-cols-4
            gap-4
          "
        >
          <h2 class="col-span-1 text-lg">แดชบอร์ด</h2>
          <div class="col-span-3">
            <!-- <div class="input-group relative">
              <span
                class="
                  material-icons
                  absolute
                  left-3
                  top-2
                  text-yr-primary-ii-500
                "
              >
                search
              </span>
              <jet-input
                type="text"
                class="w-2/5 pl-12 border-yr-primary-ii-300"
                placeholder="ค้นหา"
              />
            </div> -->
          </div>
          <div class="col-span-1">
            <div
              class="px-6 py-3 mb-5 border border-yr-primary-ii-300 rounded-lg"
            >
              <p>หมวดหมู่</p>
              <p class="text-gray-300">(อัพเดต: 2022-04-08 12:33)</p>
              <!-- <div id="for-graph" class="my-5 text-center">For Graph</div> -->
              <DoughnutChart class="mb-5" :data="consentTypeMaster" />
              <div
                v-for="(consentType, index) in consentTypeMaster"
                :key="index"
                class="flex justify-between"
              >
                <p class="text-gray-500">
                  <span
                    :class="`text-xs text-[${consentType.color}]`"
                    :style="`color: ${consentType.color}`"
                    >&#9679;</span
                  >
                  {{ consentType.name.toUpperCase() }}
                </p>
                <p>{{ consentType.count }}</p>
              </div>
            </div>
            <div class="px-6 py-3 border border-yr-primary-ii-300 rounded-lg">
              <p>สัดส่วนความยินยอม</p>
              <p class="text-gray-300">(อัพเดต: 2022-04-08 12:33)</p>
              <!-- <div id="for-graph" class="my-5 text-center">For Graph</div> -->
              <DoughnutChart2 class="mb-5" :data="categoryMaster" />
              <div
                v-for="(optionCategory, index) in categoryMaster"
                :key="index"
                class="flex justify-between"
              >
                <p class="text-gray-500">
                  <span
                    :class="`text-xs text-[${optionCategory.color}]`"
                    :style="`color: ${optionCategory.color}`"
                    >&#9679;</span
                  >
                  {{ optionCategory.name }}
                </p>
                <p>{{ optionCategory.count }}</p>
              </div>
            </div>
          </div>
          <div class="col-span-3">
            <div class="relative overflow-x-auto">
              <div class="mb-4">
                <Link
                  class="
                    font-semibold
                    py-2
                    px-4
                    mr-2
                    border
                    rounded
                    transition
                    inline-block
                  "
                  :href="
                    route('projects.consents.index', {
                      project: project.id,
                      'consent-type': '',
                    })
                  "
                  :class="
                    filters['consent-type'] == null
                      ? 'bg-yr-primary-500 text-yr-primary-ii-500 border-transparent'
                      : `bg-transparent
                        text-yr-primary-ii-500
                        border-yr-primary-ii-300
                        hover:bg-yr-primary-500 hover:text-yr-primary-ii-500 hover:border-transparent`
                  "
                  @click.prevent="setFilter()"
                >
                  ALL ({{ getConsentCount("") }})
                </Link>
                <Link
                  v-for="(consentType, index) in consentTypeMaster"
                  :key="index"
                  :href="route('projects.consents.index', {project: project.id, 'consent-type': consentType.name })"
                  class="font-semibold py-2 px-4 mr-2 border rounded transition inline-block"
                  :class="
                    filters['consent-type'] === consentType.name
                      ? 'bg-yr-primary-500 text-yr-primary-ii-500 border-transparent'
                      : `bg-transparent
                        text-yr-primary-ii-500
                        border-yr-primary-ii-300
                        hover:bg-yr-primary-500 hover:text-yr-primary-ii-500 hover:border-transparent`
                  "
                  @click.prevent="setFilter(consentType.name)"
                >
                  {{ consentType.name.toUpperCase() }}
                  ({{ consentType.count}})
                </Link>
              </div>
              <table class="w-full text-sm text-left text-gray-500">
                <thead
                  class="
                    text-xs text-yr-primary-ii-500
                    uppercase
                    bg-yr-primary-iii-500
                  "
                >
                  <tr>
                    <th scope="col" class="px-6 py-3">TIMESTAMP</th>
                    <th scope="col" class="px-6 py-3">SESSION ID</th>
                    <th scope="col" class="px-6 py-3">IP ADDRESS</th>
                    <th scope="col" class="px-6 py-3 text-center">VERSION</th>
                    <th scope="col" class="px-6 py-3 text-center">CATEGORY</th>
                    <th scope="col" class="px-6 py-3 text-center">CONSENT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="consents.length == 0">
                    <td
                      colspan="4"
                      class="
                        px-6
                        py-4
                        font-medium
                        text-gray-900
                        border-b
                        bg-white
                        text-center
                      "
                    >
                      ยังไม่มีการยอมรับคุกกี้
                    </td>
                  </tr>
                  <tr
                    v-for="(consent, index) in consentFilter"
                    :key="index"
                    class="bg-white border-b hover:bg-gray-50"
                  >
                    <th
                      scope="row"
                      class="
                        px-6
                        py-4
                        font-medium
                        text-gray-900
                        whitespace-nowrap
                      "
                    >
                      {{ getHumanDate(consent.created_at) }}
                    </th>
                    <td class="px-6 py-4 text-gray-900">
                      {{ consent.session_id }}
                    </td>
                    <td class="px-6 py-4 text-gray-900">
                      {{ consent.ip_address }}
                    </td>
                    <td class="px-6 py-4 text-gray-900 text-center">
                      {{ consent.version }}
                    </td>
                    <td class="px-6 py-4 text-gray-900 text-center">
                      {{ consent.category }}
                    </td>
                    <td class="px-6 py-4 text-gray-900 text-center">
                      {{ consent.consent }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="flex justify-center">
              <pagination class="mt-6" :links="consents.links" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateProjectModal
      :openModal="createProjectModal"
      @close-modal="closeCreateProjectModal"
    />
    <DeleteProjectModal
      :project="selectedProject"
      :openModal="deleteProjectModal"
      @close-modal="closeDeleteProjectModal"
    />
    <GetScriptModal
      :openModal="getScriptModal"
      @close-modal="closeGetScriptModal"
    />
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import moment from "moment";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import { Link } from "@inertiajs/inertia-vue3";
import CreateProjectModal from "@/Pages/Projects/Partials/CreateProjectModal";
import DeleteProjectModal from "@/Pages/Projects/Partials/DeleteProjectModal";
import GetScriptModal from "@/Pages/Consents/Partials/GetScriptModal";
import DoughnutChart from "@/Components/DoughnutChart";
import DoughnutChart2 from "@/Components/DoughnutChart2";
import Pagination from "@/Components/Pagination";

export default defineComponent({
  props: [
    "consents",
    "project",
    "countByConsents",
    "countByCategories",
    "filters",
    "version",
    "bannerSetting"
  ],

  components: {
    AppLayout,
    Link,
    JetButton,
    JetInput,
    CreateProjectModal,
    DeleteProjectModal,
    GetScriptModal,
    DoughnutChart,
    DoughnutChart2,
    Pagination,
  },

  data() {
    return {
      selectedProject: null,
      createProjectModal: false,
      deleteProjectModal: false,
      getScriptModal: false,
      cookieCategories: ["necessary", "analytic", "marketing"],
      optionCategories: [
        {
          title: "Allow",
          value: "allowed",
        },
        {
          title: "Deny",
          value: "deny",
        },
        {
          title: "Dismiss",
          value: "dismiss",
        },
        {
          title: "Informed",
          value: "informed",
        },
      ],
      activeCookieCategory: "",
      tabsContent: [
        {
          title: "บันทึกความยินยอม",
          link: "consents",
        },
        {
          title: "สแกนคุกกี้",
          link: "cookies",
        },
        {
          title: "จัดการคุกกี้",
          link: "manage",
        },
        {
          title: "ปรับแต่งแบนเนอร์",
          link: "dialogs",
        },
        // {
        //   title: "ตั้งค่าแบนเนอร์",
        //   link: "banner_setting",
        // },
      ],

      consentTypeMaster: [
          { color: "#41b883", name: "Yes", count: 0},
          { color: "#e46651", name: "No", count: 0},
          { color: "#00d8ff", name: "Informed", count: 0},
      ],
      categoryMaster: [
          { color: "#41b883", name: "necessary", count: 0},
          { color: "#e46651", name: "analytic", count: 0},
          { color: "#00d8ff", name: "marketing", count: 0},
      ]
    };
  },

  beforeMount() {
    this.setConsentTypeDataSet();
    this.setConsentCategoryDataSet();
  },

  computed: {
    consentFilter() {
      const cookies = this.consents.data.filter(
        (item) => item.option !== "deny" && item.option !== "dismiss"
      );
      if (this.activeCookieCategory) {
        return cookies.filter(
          (item) => item.consent === this.activeCookieCategory
        );
      } else {
        return cookies;
      }
    },
    lastPath() {
      return window.location.pathname.split("/").pop();
    },
  },

  methods: {
    openCreateProjectModal() {
      this.createProjectModal = true;
    },
    closeCreateProjectModal() {
      this.createProjectModal = false;
    },
    openDeleteProjectModal(project) {
      this.selectedProject = project;
      this.deleteProjectModal = true;
    },
    closeDeleteProjectModal() {
      this.selectedProject = null;
      this.deleteProjectModal = false;
    },
    openGetScriptModal() {
      this.getScriptModal = true;
    },
    closeGetScriptModal() {
      this.getScriptModal = false;
    },
    getHumanDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    setFilter(cookieCategory) {
      this.activeCookieCategory = cookieCategory ?? "";
    },
    getConsentCount(consentType) {
      if (consentType) {
        return (
          this.consentTypeMaster.find((c) => {
            return c.name == consentType;
          })?.count ?? 0
        );
      }

      return this.consentTypeMaster.reduce((total, obj) => {
        return total + obj.count;
      }, 0);
    },
    setConsentTypeDataSet() {
      let data = this.countByConsents.map((data) => {
        return data.count_consent;
      });

      return {
        backgroundColor: this.forChart,
        data: data,
      };
    },
    setConsentTypeDataSet() {
      this.consentTypeMaster.map((d) => {
        d.count =
          this.countByConsents.find((c) => {
            return c.consent == d.name;
          })?.count ?? 0;
      });
    },
    setConsentCategoryDataSet() {
      this.categoryMaster.map((d) => {
        d.count =
          this.countByCategories.find((c) => {
            return c.category == d.name;
          })?.count ?? 0;
      });
    },
    consentLength(consent, option) {
      let cookies = {};
      let field = "";
      if (option === "accept") {
        cookies = this.consents.data.filter(
          (item) => item.option !== "deny" && item.option !== "dismiss"
        );
        field = "consent";
      } else if (option === "all") {
        cookies = this.consents;
        field = "option";
      }
      //   if (consent.data) {
      //     return cookies.filter((item) => item[field] === consent).length;
      //   } else {
      //     return cookies.length;
      //   }
    },
    tabLink() {
      //   const lastPath = window.location.pathname.split("/").pop();
    },
  },
});
</script>
